module.exports = __webpack_public_path__ + "static/media/details__judge.2f06d204.svg";